/**
 * GET /v1/feedback-board/issues/:issue_id/comments — read an issue's thread.
 *
 * Admin-gated, school-scoped (KTD7). Reads the linked Linear issue's comment
 * thread live (KTD4). The backend resolves each comment's `authorKind` from
 * Linear's `botActor` (app-posted = customer) vs `user` (team) on read-back
 * (R13). Cross-tenant guard: the backend asserts `issue_id` is among the
 * requesting school's customer's linked issues before reading (U4).
 *
 * `issue_id` is a path/query param (snake_case wire convention).
 *
 * See: docs/_archive/2026-10-17-plans-sweep/plans/2026-06-18-002-feat-customer-feedback-roadmap-plan.md (U2/U4)
 */

import { z } from 'zod'
import { FeedbackCommentSchema } from '../../schemas/entities/feedback-board'

// ============================================================================
// GET /v1/feedback-board/issues/:issue_id/comments
// ============================================================================

/** Request params for the comments-list read (by `issue_id`). */
export const ListFeedbackCommentsRequestSchema = z.object({
  /** Linear issue id whose comment thread to read. */
  issue_id: z.string().trim().min(1)
})
export type ListFeedbackCommentsRequest = z.infer<typeof ListFeedbackCommentsRequestSchema>

/** Comments-list response — the issue's thread, oldest-first. */
export const ListFeedbackCommentsResponseSchema = z.object({
  /** The Linear issue id this thread belongs to (echoed for client correlation). */
  issue_id: z.string(),
  /** Comments on the issue, ordered oldest-first. */
  comments: z.array(FeedbackCommentSchema)
})
export type ListFeedbackCommentsResponse = z.infer<typeof ListFeedbackCommentsResponseSchema>
